<template>
  <div class="flex flex-jc-around p-t-10">
    <div class="input-group">
      <select class="form-control" v-model="drug.income_country_id" @change="updateCurrencyCountry">
        <option v-for="country in $AllCountries" :value="country.id">{{ country.name }} /
          {{ $AllCurrencies[country.currency_id].currency }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      selectedCurrency: 0,
      selectedCountry: 0,
      countryList: null,
    }
  },
  props: [
    'drug'
  ],
  computed: {
    $AllCurrencies() {
      return this.$store.getters['platform/currencies']
    },
    $AllCountries() {
      return this.$store.getters['platform/countries'];
    },
  },
  mounted() {
    // this.updateCurrency();
  },
  methods: {
    updateCurrencyCountry() {
      const country = this.$AllCountries.find((c) => c.id === +this.drug.income_country_id);
      this.drug.income_currency_id = country.currency_id;
    },
    updateCountry() {
      this.updateModalData(this.selectedCurrency, this.selectedCountry);
    },
    updateCountries() {
      this.selectedCountry = 0;
      this.countryList = this.countries[this.curencies[this.selectedCurrency]];
      if (this.countryList.length == 1) {
        this.selectedCountry = this.countryList[0].id;
      }
      this.updateModalData(this.selectedCurrency, this.selectedCountry);
    }
  }
}

</script>
